import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: 'online',
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
    mutations: {
      networkMode: 'online',
    },
  },
})

export default queryClient
